import { IResponse } from "@bt/shared";
import { NotifierService } from "angular-notifier";
import { HttpErrorResponse } from "@angular/common/http";

/**
 * Возвращает функцию, оповещающую пользователя о внутренних ошибках api-запроса
 * @param notifierService Сервис оповещения пользователя
 * @returns {(response: IResponse<any>) => boolean}
 * Функция, результатом которой является булево значение:
 * true - если имеются ошибки в api, false - в противном случае
 */
export const buildCatchingApiError = (notifierService?: NotifierService) => {
  return (response: IResponse<any>): boolean => {
    if (notifierService)
      response.errorMsgs.forEach(err =>
        notifierService.notify("error", err));

    return !!response.errorMsgs.length;
  }
};


/**
 * Возвращает функцию, оповещающую пользователя об ошибках HTTP
 * @param notifierService Сервис оповещения пользователя
 * @param externalAction Дополнительное действие
 * @returns {(response: IResponse<any>) => boolean}
 * Функция, оповещающая пользователя об ошибках запроса
 */
export const buildCatchingHttpError = (
  notifierService?: NotifierService,
  externalAction?: (error: HttpErrorResponse) => void,
) => {
  return (error: HttpErrorResponse) => {
    if (notifierService) {
      const errorMessages = error.error && error.error.errorMsgs;
      if (Array.isArray(errorMessages) && errorMessages.length) {
        errorMessages.forEach(err =>
          notifierService.notify("error", err));
      } else {
        notifierService.notify('error', error.statusText);
      }
    }

    externalAction && externalAction(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/utils/catchingException.ts